import { useRouter } from 'next/router';
import React, { useState } from 'react';

import './CommunityGroupDropdown.scss';
import { getString } from '../../../helpers/styles';
import icons from '../../../shared/assets/icons/redesign';

const { Lock, ChevronUp, ChevronDown, ChevronRight } = icons;

export default function CommunityGroupDropdown({ list, currentGroup }) {
  const router = useRouter();
  const [isOpen, setIsOpen] = useState(false);

  const groupHasNewActivity = currentGroup.topics.find((topic) => {
    if (!topic.follow) return true;

    return (
      new Date(topic.follow.lastSeenAt) <
      (topic.events.length
        ? new Date(
            Math.max.apply(
              null,
              topic.events.map(
                ({ createdAt, updatedAt }) => new Date(updatedAt || createdAt)
              )
            )
          )
        : new Date(topic.createdAt))
    );
  });

  return (
    <div
      className={getString([
        {
          value: 'communityGroupDropdown',
          condition: true
        },
        {
          value: 'communityGroupDropdown-open',
          condition: isOpen
        }
      ])}
    >
      <div
        onClick={() => setIsOpen(!isOpen)}
        className="communityGroupDropdown-current-group"
      >
        <div>
          <div
            className={getString([
              {
                value: 'communityGroupDropdown-marker',
                condition: true
              },
              {
                value: 'communityGroupDropdown-marker-active',
                condition: groupHasNewActivity
              }
            ])}
          >
            &#8226;
          </div>

          <p className="communityGroupDropdown-current-group-name">
            {currentGroup.displayName}
          </p>
        </div>

        <div className="communityGroupDropdown-current-group-icons">
          {currentGroup.visibility !== 'PUBLIC' && (
            <Lock
              className="
              communityGroupDropdown-icon communityGroupDropdown-lock-icon
            "
            />
          )}

          {isOpen ? (
            <ChevronUp className="communityGroupDropdown-icon" />
          ) : (
            <ChevronDown className="communityGroupDropdown-icon" />
          )}
        </div>
      </div>

      {isOpen && (
        <ul className="communityGroupDropdown-list">
          {list.map((group) => (
            <li
              key={group.xuid}
              onClick={() => (
                router.push(`/community/${group.uri}`), setIsOpen(false)
              )}
              className="communityGroupDropdown-list-item"
            >
              <div>
                <div
                  className={getString([
                    {
                      value: 'communityGroupDropdown-marker',
                      condition: true
                    },
                    {
                      value: 'communityGroupDropdown-marker-active',
                      condition: false
                    }
                  ])}
                >
                  &#8226;
                </div>

                <p className="communityGroupDropdown-list-item-name">
                  {group.displayName}
                </p>
              </div>

              <div className="communityGroupDropdown-list-item-icons">
                {group.visibility !== 'PUBLIC' && (
                  <Lock
                    className="
                    communityGroupDropdown-icon communityGroupDropdown-lock-icon
                  "
                  />
                )}

                <ChevronRight
                  className="
                  communityGroupDropdown-icon
                  communityGroupDropdown-chevron-right-icon"
                />
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
